import { useTranslation } from 'react-i18next';
import { useAllInfluencerCategoryOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const InfluencerCategoryField = (
  props: Omit<MultipleSelectorFieldProps<MarketplaceFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();

  return (
    <SelectorField
      help={t('Tooltip.Categories')}
      title={t('Selector.Influencer Categories')}
      options={allInfluencerCategoryOptions}
      name={MarketplaceFormKeys.influencerCategoryIds}
      multiple
      {...props}
    />
  );
};
